import styled from 'styled-components';

export default styled.span`
  font-family: var(--google-sora-cdn);
  font-weight: 800;
  font-size: 15px;
  line-height: 40px;
  color: #ffffff;
  white-space: nowrap;
`;
